<template>
    <div class="newPage">
        <div class="content">
            <div class="VOCNavBar">
                <!--<div class="title">选择模块</div>-->
                <el-tabs type="border-card" class="statisticBoxR scrollbar" v-model="activeName">
                    <el-tab-pane name="1">
                        <span slot="label">自定义表头</span>
                        <div class="">
                            <div class="moduleContent">
                                <div class="moduleTitle">
                                    表头 <i class="el-icon-plus" @click="openHeader"></i>
                                </div>
                                <div class="moduleSelect">
                                    <el-select size="mini" v-model="queryParams.header.id" placeholder="请选择">
                                        <template v-for="item in queryList">
                                            <el-option
                                                    v-if="item.type===0"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="moduleInput">
                                    <el-input size="mini" v-model="queryParams.header.header"
                                              placeholder="请输入主表头"></el-input>
                                </div>
                                <div class="moduleInput">
                                    <el-input size="mini" v-model="queryParams.header.dateHeader"
                                              placeholder="请输入副表头"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="moduleContent">
                                <div class="moduleTitle">
                                    标题 <i class="el-icon-plus" @click="openTitle"></i>
                                </div>
                                <div class="moduleSelect">
                                    <el-select size="mini" v-model="queryParams.title.id" placeholder="请选择">
                                        <template v-for="item in queryList">
                                            <el-option
                                                    v-if="item.type===1"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="moduleInput">
                                    <el-input size="mini" v-model="queryParams.title.title"
                                              placeholder="请输入主标题"></el-input>
                                </div>
                                <div class="moduleInput">
                                    <el-input size="mini" v-model="queryParams.title.dateTitle"
                                              placeholder="请输入副标题"></el-input>
                                </div>
                            </div>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane name="2" label="预制表头">
                        <div class="statisticBoxR scrollbar">
                            <div class="moduleContent">

                                <div class="moduleSelect">
                                    <el-select size="mini" v-model="PrecastHeadId" placeholder="请选择模板">
                                        <el-option
                                                v-for="item in PrecastHeadList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="moduleSelect">
                                    <el-cascader
                                            v-model="queryParams.precastHead.city"
                                            :options="cityList"
                                            :props="cityProps"
                                            clearable
                                            size="mini"
                                    ></el-cascader>
                                </div>
                                <div class="moduleInput">
                                    <el-date-picker
                                            v-model="queryParams.precastHead.time"
                                            size="mini"
                                            type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="选择日期时间">
                                    </el-date-picker>
                                </div>
                                <div class="moduleInput">
                                    <el-button type="primary" size="mini" @click="precastHeadOpen = true">预览</el-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <div class="statisticBoxR staCenter scrollbar">
                    <div class="moduleContent">
                        <div class="moduleTitle">
                            段落 <i class="el-icon-plus" @click="openParagraph"></i>
                        </div>
                        <div class="moduleList">
                            <div class="moduleItem" v-for="(item,index) in ParamsModuleList" :key="item.id">
                                <span class="name">
                                   {{index+1}}. {{item.name}}
                                </span>
                                <el-button size="mini" type="primary" @click="editParagraph(item,index)">编辑</el-button>
                                <el-button size="mini" type="danger" @click="deleteParagraph(item,index)">删除</el-button>
                                <el-button size="mini" type="primary" @click="upParagraph(item,index)"
                                           class="el-icon-arrow-up"></el-button>
                                <el-button size="mini" type="primary" @click="downParagraph(item,index)"
                                           class="el-icon-arrow-down"></el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btnBox">
                    <el-button type="primary" size="mini" @click="getList">获取报告</el-button>
                    <el-button type="primary" size="mini" @click="saveModlue">保存模板</el-button>
                    <el-button type="primary" size="mini" @click="reportDown" :disabled="!isgetReport">下载报告</el-button>
                </div>
            </div>
            <div class="showContent" v-loading="loading">
                <breadcrumb></breadcrumb>
                <div>
                    <pdf v-for="i in numPages" :key="i" :src="src" :page="i" ref="myPdfComponent"></pdf>
                </div>
            </div>
        </div>


        <el-dialog
                class="reportDialog"
                title="编辑段落"
                :visible.sync="paragraphOpen"
                width="90%"
                :before-close="handleClose">

            <div class="paragraphBox">
                <div class="paragraphCenter">
                    <div class="paragraphList">
                        <div class="navBarItem">
                            <div class="navBarTitle">选择模块</div>
                            <div class="navBarValue">
                                <el-cascader
                                        size="mini"
                                        @change="cascaderChange"
                                        v-model="paragraphParams.moduleId"
                                        :options="reportListMenu"
                                        :props="{ label: 'name',value:'id' }"
                                ></el-cascader>
                            </div>
                        </div>
                        <div class="navBarItem">
                            <div class="navBarTitle">开始日期</div>
                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="paragraphParams.startTime"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="navBarItem">
                            <div class="navBarTitle">结束日期</div>
                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="paragraphParams.endTime"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                </el-date-picker>
                            </div>
                        </div>
                        <template v-if="paragraphParams.type==1">
                            <div class="navBarItem">
                                <div class="title">选择城市</div>
                                <div class="statisticBox scrollbar cityAndStation">
                                    <div class="item">
                                        <el-radio-group v-model="paragraphParams.city" @change="cityChange">
                                            <div v-for="(item,index) in query.citys" :key="index">
                                                <el-radio :label='item.city'>{{item.city}}</el-radio>
                                            </div>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                            <div class="navBarItem">
                                <div class="title">选择站点</div>
                                <div class="statisticBox scrollbar cityAndStation">
                                    <div class="item">
                                        <el-checkbox-group v-model="paragraphParams.stations">
                                            <div v-for="(item,index) in query.stations" :key="index">
                                                <el-checkbox :label='item.station'
                                                             v-if="paragraphParams.city===item.city">
                                                    {{item.station}}
                                                </el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="paragraphParams.type==2">
                            <div class="navBarItem">
                                <div class="title">选择城市</div>
                                <div class="statisticBox scrollbar cityAndStation">
                                    <div class="item">
                                        <el-cascader
                                                v-model="paragraphParams.cityName"
                                                :options="cityList"
                                                :props="cityProps"
                                                clearable
                                                size="mini"
                                        ></el-cascader>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="paragraphRight">
                    <div class="btnBox">
                        <el-button type="primary" size="mini" @click="handleParagraph">预览</el-button>
                        <el-button size="mini" @click="paragraphOpen = false">取 消</el-button>
                        <el-button size="mini" v-if="nowparagraph" type="primary" @click="saveParagraph">保 存</el-button>
                    </div>
                    <div v-loading="loading" class="paragraphRightBox">
                        <pdf v-for="i in paragraphnumPages" :key="i" :src="paragraphSrc" :page="i"
                             ref="paragraphComponent"></pdf>
                    </div>
                </div>
            </div>

        </el-dialog>


        <el-dialog
                class="reportDialog"
                title="编辑表头"
                :visible.sync="headerOpen"
                width="90%"
                :before-close="handleClose">

            <div class="paragraphBox">
                <div class="paragraphCenter">
                    <div class="paragraphList">
                        <div class="navBarItem">
                            <el-select size="mini" v-model="queryParams.header.id" placeholder="请选择">
                                <template v-for="item in queryList">
                                    <el-option
                                            v-if="item.type===0"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </template>
                            </el-select>
                        </div>
                        <div class="navBarItem">
                            <el-input class="paragraphInput" size="mini" v-model="queryParams.header.header"
                                      placeholder="请输入主表头"></el-input>
                        </div>
                        <div class="navBarItem">
                            <el-input class="paragraphInput" size="mini" v-model="queryParams.header.dateHeader"
                                      placeholder="请输入副表头"></el-input>
                        </div>
                        <div class="navBarItem">
                            <el-button size="mini" type="primary" @click="previewHeader">预览</el-button>
                            <el-button size="mini" type="primary" @click="headerOpen = false">关闭</el-button>
                        </div>
                    </div>
                </div>
                <div class="paragraphRight">
                    <div v-loading="loading" class="paragraphRightBox">
                        <pdf v-for="i in headernumPages" :key="i" :src="headerSrc" :page="i"
                             ref="headerComponent"></pdf>
                    </div>
                </div>
            </div>
        </el-dialog>


        <el-dialog
                title="编辑标题"
                :visible.sync="titleOpen"
                width="90%"
                class="reportDialog"
                :before-close="handleClose">

            <div class="paragraphBox">
                <div class="paragraphCenter">
                    <div class="paragraphList">
                        <div class="navBarItem">
                            <el-select size="mini" v-model="queryParams.title.id" placeholder="请选择">
                                <template v-for="item in queryList">
                                    <el-option
                                            v-if="item.type===1"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </template>
                            </el-select>
                        </div>
                        <div class="navBarItem">
                            <el-input class="paragraphInput" size="mini" v-model="queryParams.title.title"
                                      placeholder="请输入主标题"></el-input>
                        </div>
                        <div class="navBarItem">
                            <el-input class="paragraphInput" size="mini" v-model="queryParams.title.dateTitle"
                                      placeholder="请输入副标题"></el-input>
                        </div>
                        <div class="navBarItem">
                            <el-button size="mini" type="primary" @click="previewTitle">预览</el-button>
                            <el-button size="mini" type="primary" @click="titleOpen = false">关闭</el-button>
                        </div>
                    </div>
                </div>
                <div class="paragraphRight">
                    <div v-loading="loading" class="paragraphRightBox">
                        <pdf v-for="i in titlenumPages" :key="i" :src="titleSrc" :page="i"
                             ref="titleComponent"></pdf>
                    </div>
                </div>
            </div>
        </el-dialog>


        <el-dialog
                title="预制表头"
                :visible.sync="precastHeadOpen"
                width="80%"
                class="reportDialog"
                :before-close="handleClose">

            <div class="paragraphBox">
                <div class="paragraphCenter">
                    <div class="paragraphList">
                        <div class="navBarItem">
                            <el-select size="mini" v-model="PrecastHeadId" placeholder="请选择模板">
                                <el-option
                                        v-for="item in PrecastHeadList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="navBarItem">
                            <el-cascader
                                    v-model="queryParams.precastHead.city"
                                    :options="cityList"
                                    :props="cityProps"
                                    clearable
                                    size="mini"
                            ></el-cascader>
                        </div>
                        <div class="navBarItem">
                            <el-date-picker
                                    v-model="queryParams.precastHead.time"
                                    size="mini"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div class="navBarItem">
                            <el-button size="mini" type="primary" @click="getPrefabrication">预览</el-button>
                            <el-button size="mini" type="primary" @click="precastHeadOpen = false">关闭</el-button>
                        </div>
                    </div>
                </div>
                <div class="paragraphRight">
                    <div v-loading="loading" class="paragraphRightBox">
                        <pdf v-for="i in precastHeadnumPages" :key="i" :src="precastHeadSrc" :page="i"
                             ref="precastHeadComponent"></pdf>
                    </div>
                </div>
            </div>
        </el-dialog>


    </div>
</template>

<script>

    import Breadcrumb from "../../../components/breadcrumb";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    import url from "../../../utils/UrlApi"
    // import pdf from 'vue-pdf'
    import pdf from '../../../components/vue-pdf'
    import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

    export default {
        name: "VOCcomReport",
        components: {Breadcrumb, pdf},
        computed: {
            id: {
                get() {
                    return this.$route.query.id
                }
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },

                queryParams: {
                    header: {
                        id: '',
                        header: '',
                        dateHeader: ''
                    },
                    title: {
                        id: '',
                        title: '',
                        dateTitle: ''
                    },
                    texts: [],
                    precastHead: {
                        city: [],
                        time: ''
                    }
                },

                precastHead: {},    ///  预制表头数据
                tableData: null,
                queryList: null,
                pdfUrl: "",
                src: '',
                numPages: 0,
                page: 1,
                currentPage: 0,
                isShowTabel: true,
                loading: false,
                moduleList: [],

                cityList: [],
                cityProps: {
                    multiple: false,
                    emitPath: true,
                    label: "lable",
                    value: "lable"
                },

                isgetReport: false,  //  是否生成报告
                query: {},
                open: false,
                wordtemplate: '',
                Base64Data: '',
                paragraphOpen: false,
                headerOpen: false,
                titleOpen: false,
                precastHeadOpen: false,
                reportListMenu: [],
                paragraphParams: {
                    type: 0,  //  1 VOC模块  2 普通模块   区别 VOC模块 指定城市与站点   ，普通模块选择省市
                    city: '',
                    stations: [],
                    cityName: []
                },
                paragraphSrc: '',
                paragraphnumPages: 0,

                headerSrc: '',
                headernumPages: 0,

                titleSrc: '',
                titlenumPages: 0,

                precastHeadSrc: '',
                precastHeadnumPages: 0,


                ParamsModuleList: [],
                nowparagraph: "", //  生成文件后的值
                editIndex: '',     //  当前在编辑的下标

                activeName: '1',
                PrecastHeadList: [],
                PrecastHeadId: ''
            }
        },
        created() {
            this.getqueryList()
            this.getCityList()
            this.getwordTemplatePrecastHeadList()
        },
        mounted() {
            this.getPara()
        },
        methods: {

            getPara() {
                console.log(this.$route.query.para)
                if (this.$route.query.para) {
                    let data = JSON.parse(this.$route.query.para)
                    data.type = 2   //   强制将模板参数重置

                    //  分别处理 自定义表头 和 预制表头 参数
                    if (data.header) {
                        data.precastHead = {
                            city: [],
                            time: ''
                        }
                        this.activeName = '1'
                    } else {
                        data.header = {
                            id: '',
                            header: '',
                            dateHeader: ''
                        }

                        data.title = {
                            id: '',
                            title: '',
                            dateTitle: ''
                        }


                        if (data.precastHead.cityPath) {
                            data.precastHead.city = data.precastHead.cityPath.split(',')
                        } else {
                            data.precastHead.city = []
                        }
                        this.activeName = '2'
                    }

                    this.queryParams = data
                    this.ParamsModuleList = data.texts
                } else {
                    this.queryParams = {
                        header: {
                            id: '',
                            header: '',
                            dateHeader: ''
                        },
                        title: {
                            id: '',
                            title: '',
                            dateTitle: ''
                        },
                        texts: [],
                        precastHead: {
                            city: [],
                            time: ''
                        }
                    }
                    this.ParamsModuleList = []
                    this.activeName = '1'
                }
            },

            //  查询预制表头列表

            getwordTemplatePrecastHeadList() {
                let data = {
                    params: {}
                }
                this.$http.get(url.wordTemplatePrecastHeadList, data).then(res => {
                    if (res.data.code === '200') {
                        this.PrecastHeadList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  预览 预制表头
            getPrefabrication() {
                let data = JSON.parse(JSON.stringify(this.queryParams.precastHead))
                data.city = this.queryParams.precastHead.city[this.queryParams.precastHead.city.length - 1]

                this.precastHeadOpen = true
                this.$http.get(url.wordTemplateprecastHead, {params: data}).then(res => {
                    if (res.data.code === '200') {
                        let da = res.data.data.base64
                        let datas = 'data:application/pdf;base64,' + da
                        this.Base64Data = da
                        this.precastHeadSrc = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.precastHeadSrc.promise.then(pdf => {
                            this.precastHeadnumPages = pdf.numPages;
                        });

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))


                if (this.activeName === '1') {
                    data.precastHead = null

                }

                if (this.activeName === '2') {
                    data.header = null
                    data.title = null
                    data.precastHead.city = this.queryParams.precastHead.city[this.queryParams.precastHead.city.length - 1]
                }

                data.texts = []

                this.ParamsModuleList.forEach(res => {
                    data.texts.push({
                        id: res.id,
                        name: res.name
                    })
                })


                this.loading = true
                this.$http.post(url.wordTemplategenerate, data).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        let da = res.data.message
                        let datas = 'data:application/pdf;base64,' + da
                        this.Base64Data = da
                        this.src = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.src.promise.then(pdf => {
                            this.numPages = pdf.numPages;
                        });

                        this.isgetReport = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  查询城市树
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  保存为模板
            saveModlue() {
                this.$prompt('请输入模板名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    this.loading = true
                    let data = JSON.parse(JSON.stringify(this.queryParams))


                    if (this.activeName === '1') {
                        data.precastHead = null

                    }

                    if (this.activeName === '2') {
                        data.header = null
                        data.title = null
                        data.precastHead.city = this.queryParams.precastHead.city[this.queryParams.precastHead.city.length - 1]
                        data.precastHead.cityPath = this.queryParams.precastHead.city.join()

                    }

                    data.texts = []

                    this.ParamsModuleList.forEach(res => {
                        data.texts.push({
                            id: res.id,
                            name: res.name
                        })
                    })
                    data.type = 3
                    data.name = value

                    this.$http.post(url.wordTemplategenerate, data).then(res => {
                        if (res.data.code === '200') {
                            this.$message.success('模板保存成功')
                            this.loading = false
                            let da = res.data.message
                            let datas = 'data:application/pdf;base64,' + da
                            this.Base64Data = da
                            this.src = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                            this.src.promise.then(pdf => {
                                this.numPages = pdf.numPages;
                            });

                            this.isgetReport = true
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            //  查询模块类型
            cascaderChange(node) {
                let data = {
                    id: node[node.length - 1]
                }
                //     查询模块类型
                this.$http.get(url.wordTemplatemoduleType, {
                    params: data
                }).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        this.paragraphParams.type = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },

            cityChange() {
                //  每次切换 城市,重置站点数据
                // this.queryParams.stations = []
            },


            //  预览表头
            previewHeader() {

                let data = this.queryParams.header

                this.$http.get(url.wordTemplateheaderPdf, {
                    params: data
                }).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        let da = res.data.message
                        let datas = 'data:application/pdf;base64,' + da
                        this.headerSrc = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.headerSrc.promise.then(pdf => {
                            this.headernumPages = pdf.numPages;
                        });
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            //   预览标题
            previewTitle() {
                let data = this.queryParams.title

                this.$http.get(url.wordTemplatetitlePdf, {
                    params: data
                }).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        let da = res.data.message
                        let datas = 'data:application/pdf;base64,' + da
                        this.titleSrc = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.titleSrc.promise.then(pdf => {
                            this.titlenumPages = pdf.numPages;
                        });
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },

            //  下载
            reportDown() {
                // let data = JSON.parse(JSON.stringify(this.queryParams))
                // data.token = localStorage.getItem('token')
                // data.header = JSON.stringify(data.header)
                // data.title = JSON.stringify(data.title)
                // data.texts = []
                // this.queryParams.texts.forEach(res => {
                //     data.texts.push({
                //         id: res
                //     })
                // })
                // data.texts = JSON.stringify(data.texts)
                // let allUrl = url.wordTemplategenerateExport + params(data)
                // window.open(allUrl, '_blank')


                let URL = this.dataURLtoBlob(this.Base64Data);
                var reader = new FileReader();
                reader.readAsDataURL(URL);
                reader.onload = function (e) {
                    // 兼容IE
                    if (window.navigator.msSaveOrOpenBlob) {
                        var bstr = window.atob(e.target.result.split(",")[1]);
                        var n = bstr.length;
                        var u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        var blob = new Blob([u8arr]);
                        window.navigator.msSaveOrOpenBlob(blob, '报告.pdf');
                    } else {
                        // 转换完成，创建一个a标签用于下载
                        const a = document.createElement('a');
                        a.download = '报告.pdf'; // 这里写你的文件名
                        a.href = e.target.result;
                        document.body.appendChild(a)
                        a.click();
                        document.body.removeChild(a)
                    }
                }
            },

            //  转PDF
            dataURLtoBlob(dataurl) {
                var bstr = window.atob(dataurl)
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: 'pdf'});
            },

            //   获取 标题。表头。段落 参数
            getqueryList() {
                let data = {}
                this.$http.get(url.wordTemplatelist, data).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.queryList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  打开 段落弹框
            openParagraph() {
                this.paragraphOpen = true
                //  初始化参数
                this.paragraphParams = {
                    type: 0,
                    city: '',
                    stations: [],
                }
                this.paragraphSrc = ''
                this.editIndex = ''
                this.moduleList = []
                this.nowparagraph = ''
                this.paragraphnumPages = 0


                this.getanalysisReportlist()
                this.getReportQueryList()
                this.getCityList()
            },

            openHeader() {
                this.headerOpen = true
            },

            openTitle() {
                this.titleOpen = true
            },


            // 获取 报告分析种类
            getanalysisReportlist() {
                this.$http.get(url.wordTemplatetree).then(res => {
                    // console.log(res)
                    this.reportListMenu = res.data.data

                })
            },
            //  获取XXXX分析的参数
            getReportModule(id) {
                let data = {
                    id: id
                }
                this.$http.get(url.analysisReportlist, {params: data}).then(res => {
                    this.moduleList = res.data.data
                })
            },

            //  获取报告参数
            getReportQueryList() {
                let data = {}
                this.$http.get(url.analysisReportcitys, data).then(res => {
                    if (res.data.code === '200') {
                        this.query = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            handleParagraph() {
                let da
                let data = JSON.parse(JSON.stringify(this.paragraphParams))
                data.stations = this.paragraphParams.stations.join()

                if (!data.moduleId) {
                    return this.$message.error('请选择模块')
                }

                if (this.paragraphParams.cityName && this.paragraphParams.cityName.length > 0) {
                    data.cityName = this.paragraphParams.cityName[this.paragraphParams.cityName.length - 1]
                }

                data.moduleId = this.paragraphParams.moduleId[this.paragraphParams.moduleId.length - 1]
                data.moduleIds = this.paragraphParams.moduleId

                this.loading = true
                this.$http.post(url.wordTemplategeneratePdf, data).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        this.nowparagraph = res.data.data  //  保存返回参数

                        da = res.data.data.base64
                        let datas = 'data:application/pdf;base64,' + da
                        this.paragraphSrc = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.paragraphSrc.promise.then(pdf => {
                            this.paragraphnumPages = pdf.numPages;
                        });
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            saveParagraph() {

                this.paragraphOpen = false

                if (!this.nowparagraph) {
                    return console.log('没有生成数据')
                }
                let data = JSON.parse(JSON.stringify(this.nowparagraph))

                if (this.editIndex === '') {

                    this.ParamsModuleList.push(data)
                } else {
                    this.ParamsModuleList.splice(this.editIndex, 1, data)
                }
            },

            //  编辑段落

            editParagraph(item, index) {
                //     初始化 请求参数


                let data = {
                    id: item.id,
                    type: '1'     //  1 段落
                }

                this.paragraphSrc = ''
                this.paragraphnumPages = 0

                this.$http.get(url.wordTemplateinfo, {params: data}).then(res => {
                    if (res.data.code === '200') {
                        let response = res.data.data
                        this.editIndex = index
                        this.paragraphOpen = true
                        let paragraphParams = JSON.parse(response.para)

                        //  请求数据处理
                        paragraphParams.stations = paragraphParams.stations.split(",")
                        paragraphParams.moduleId = paragraphParams.moduleIds
                        this.paragraphParams = paragraphParams
                        this.nowparagraph = item

                        let da = response.base64
                        let datas = 'data:application/pdf;base64,' + da
                        this.paragraphSrc = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.paragraphSrc.promise.then(pdf => {
                            this.paragraphnumPages = pdf.numPages;
                        });


                        this.cascaderChange(paragraphParams.moduleIds)

                        this.getanalysisReportlist()
                        this.getReportQueryList()
                        this.getCityList()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })


            },
            //删除段落
            deleteParagraph(item, index) {

                this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.ParamsModuleList.splice(index, 1)
                    this.$message.success('段落成功')
                }).catch(() => {
                });
            },
            // 上调段落
            upParagraph(item, index) {
                if (index === 0) {
                    return
                }
                //在上一项插入该项
                this.ParamsModuleList.splice(index - 1, 0, (this.ParamsModuleList[index]))
                //删除后一项
                this.ParamsModuleList.splice(index + 1, 1)

            },
            //  下调段落
            downParagraph(item, index) {
                if (index === (this.ParamsModuleList.length - 1)) {
                    return
                }
                // 在下一项插入该项
                this.ParamsModuleList.splice(index + 2, 0, (this.ParamsModuleList[index]))
                // 删除前一项
                this.ParamsModuleList.splice(index, 1)
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            }
        },
        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            next()
            this.getPara()
        },
    }
</script>

<style scoped lang="less">
    @import "../../../assets/vocContent";

    .precastDrawer {
        width: 50%;
    }

    .cityAndStation {
        display: flex;
        .item {
            flex: 1;
            border-right: 1px solid #ddd;
            padding: 4px;
        }
        .item:last-child {
            border-right: 0;
        }
    }

    .dialog-footer {
        margin: 20px 0;
    }

    .VOCContent {
        .list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            .item {
                width: 48%;
                height: 300px;
                margin: 30px 1%;
                box-shadow: 4px 4px 4px 4px #ddd;
                .name {
                    margin: 10px 0;
                    text-align: center;
                }
                .img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .paragraphBox {
        display: flex;
        .paragraphLeft {
            /*flex: 1;*/
            /*width: 200px;*/
            border-right: 1px solid #ddd;
            padding: 0 8px
        }
        .paragraphCenter {
            width: 33%;
            /*flex: 1;*/
            padding: 0 8px;
            border-right: 1px solid #ddd;
            /*padding: 0 8px;*/

            .paragraphList {
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
            }
            .navBarItem {
                /*min-width: 400px;*/
                width: 100%;
                margin: 10px 0;
                display: flex;
                align-items: center;
                .navBarTitle {
                    margin-right: 8px;
                }
                .navBarValue {
                }
                .paragraphInput {
                    width: 100%;
                }
            }
        }
        .paragraphRight {
            /*width: 400px;*/
            flex: 1;
            .btnBox {
                text-align: center;
            }
            .paragraphRightBox {
                min-height: 100px;
            }
        }
    }

    .moduleList {
        .moduleItem {
            margin: 4px 0;
            display: flex;
            .name {
                flex: 1;
                white-space: nowrap;

                text-overflow: ellipsis;

                overflow: hidden;

                word-break: break-all;
            }
        }
    }

    .headerBox1 {
        display: flex;
        .headerLeft {
            width: 300px;
            border-right: 1px solid #ddd;
            padding: 8px;
            div {
                margin: 4px 0;
            }
        }
        .headerRight {
            flex: 1;
        }
    }


</style>
